/* istanbul ignore file */
import Announcement from './Announcement';

export default Announcement;
